import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { adSlotVisibleGranular } from '../utils/adsEnabled';
import { selectAdSurfaceEnabled, selectSitePublicLoaded } from '../store/reducers/sitePublicReducer';

/**
 * Server-driven ad surface (Website.adsStaticEnabled | adsManagedEnabled) plus optional per-page env kill-switches.
 */
export function useAdSurfaceAndSlot(pageKey) {
  const loaded = useSelector(selectSitePublicLoaded);
  const adSurfaceEnabled = useSelector(selectAdSurfaceEnabled);
  const slotVisible = useMemo(
    () => adSlotVisibleGranular(pageKey, adSurfaceEnabled),
    [pageKey, adSurfaceEnabled],
  );
  return { loaded, adSurfaceEnabled, slotVisible };
}
